module.exports = __webpack_public_path__ + "static/media/aw.0cd7e031.svg";